__turbopack_context__.v({
  "active-path": "ProgressOnePage-module-scss-module__V58GkG__active-path",
  "back": "ProgressOnePage-module-scss-module__V58GkG__back",
  "content": "ProgressOnePage-module-scss-module__V58GkG__content",
  "gallery": "ProgressOnePage-module-scss-module__V58GkG__gallery",
  "gallery__main": "ProgressOnePage-module-scss-module__V58GkG__gallery__main",
  "intro": "ProgressOnePage-module-scss-module__V58GkG__intro",
  "introBottom": "ProgressOnePage-module-scss-module__V58GkG__introBottom",
  "introBottom__date": "ProgressOnePage-module-scss-module__V58GkG__introBottom__date",
  "introBottom__list": "ProgressOnePage-module-scss-module__V58GkG__introBottom__list",
  "introInner": "ProgressOnePage-module-scss-module__V58GkG__introInner",
  "layoutPlug": "ProgressOnePage-module-scss-module__V58GkG__layoutPlug",
  "lineWrapper": "ProgressOnePage-module-scss-module__V58GkG__lineWrapper",
  "path": "ProgressOnePage-module-scss-module__V58GkG__path",
  "title": "ProgressOnePage-module-scss-module__V58GkG__title",
  "titleString": "ProgressOnePage-module-scss-module__V58GkG__titleString",
});
